(function () {
  if (customElements.get('tile-filter')) return;

  var LETTERS = ['XXXS', 'XXS', 'XS', 'XS/S', 'S', 'S/M', 'M', 'M/L', 'L', 'L/XL', 'XL', 'XXL'];
  var GROUPS = ['groesse', 'breite', 'laenge', 'weitere'];

  function classify(label) {
    var clean = (label || '').trim();
    var upper = clean.toUpperCase();
    var parts = clean.split(/\s+/);

    if (LETTERS.indexOf(upper) > -1) {
      return { group: 'groesse', order: 0, num: LETTERS.indexOf(upper) + 1, suffix: '0', text: '' };
    }

    if (parts.length === 2 && LETTERS.indexOf(parts[0].toUpperCase()) > -1) {
      var tail = parts[1].toLowerCase();
      var rank = tail === 'short' ? '1' : tail === 'long' ? '2' : '3' + tail;
      return { group: 'groesse', order: 0, num: LETTERS.indexOf(parts[0].toUpperCase()) + 1, suffix: rank, text: '' };
    }

    if (parts.length === 2) {
      var amount = parseFloat(parts[0].replace(',', '.'));
      var unit = parts[1].toLowerCase();
      if (amount > 0) {
        if (unit === 'g') return { group: 'groesse', order: 1, num: Math.round(amount * 100), suffix: '', text: '' };
        if (unit === 'ml') return { group: 'groesse', order: 2, num: Math.round(amount * 100), suffix: '', text: '' };
        if (unit === 'cm') return amount < 10
          ? { group: 'breite', order: 3, num: Math.round(amount * 100), suffix: '', text: '' }
          : { group: 'laenge', order: 4, num: Math.round(amount * 100), suffix: '', text: '' };
        if (unit === 'm') return { group: 'laenge', order: 4, num: Math.round(amount * 10000), suffix: '', text: '' };
      }
    }

    return { group: 'weitere', order: 5, num: 0, suffix: '', text: clean.toLowerCase() };
  }

  function sortKey(entry) {
    if (entry.group === 'weitere') return entry.text;
    return String(entry.order) + String(entry.num).padStart(10, '0') + entry.suffix;
  }

  class TileFilter extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.sectionId = this.dataset.sectionId;
      this.state = { now: false, groups: [], types: [], sizes: [] };

      this.onChange = this.onChange.bind(this);
      this.onRemove = this.onRemove.bind(this);
      this.refresh = this.refresh.bind(this);

      document.addEventListener('change', this.onChange);
      this.addEventListener('click', this.onRemove);

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup(), { once: true });
      } else {
        this.setup();
      }
    }

    setup() {
      this.watch();
      this.watchSticky();
      this.refresh();
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onChange);
      this.observer && this.observer.disconnect();
      this.tabObserver && this.tabObserver.disconnect();
      this.stickyObserver && this.stickyObserver.disconnect();
    }

    get section() {
      return document.getElementById('shopify-section-' + this.sectionId) || this.closest('.shopify-section') || document;
    }

    get panel() {
      var panels = this.section.querySelectorAll('[role="tabpanel"]');
      if (!panels.length) return this.section.querySelector('.tiles-canvas') || this.section;
      for (var i = 0; i < panels.length; i++) {
        if (!panels[i].hidden) return panels[i];
      }
      return panels[0];
    }

    get forms() {
      return Array.from(document.querySelectorAll('form[data-tile-form][data-tile-section="' + this.sectionId + '"]'));
    }

    get badges() {
      return Array.from(this.querySelectorAll('[data-tile-badge]'));
    }

    get totals() {
      return Array.from(document.querySelectorAll('[data-tile-total][data-tile-section="' + this.sectionId + '"]'));
    }

    watch() {
      var canvas = this.section.querySelector('.tiles-canvas');
      if (!canvas) return;

      this.observer = new MutationObserver(() => {
        clearTimeout(this.refreshTimer);
        this.refreshTimer = setTimeout(this.refresh, 60);
      });
      this.observer.observe(canvas, { childList: true, subtree: true });

      var tabs = this.section.querySelector('tabs-element');
      if (tabs) {
        this.tabObserver = new MutationObserver(() => {
          clearTimeout(this.refreshTimer);
          this.refreshTimer = setTimeout(this.refresh, 60);
        });
        this.tabObserver.observe(tabs, { attributes: true, attributeFilter: ['selected-index'] });
      }
    }

    watchSticky() {
      var sticky = this.querySelector('[data-tile-sticky]');
      if (!sticky) return;

      var button = sticky.querySelector('.button');
      button.style.opacity = 0;
      button.style.visibility = 'hidden';

      this.stickyObserver = new IntersectionObserver((entries) => {
        var visible = entries[0].isIntersecting;
        button.style.opacity = visible ? 1 : 0;
        button.style.visibility = visible ? 'visible' : 'hidden';
      }, { rootMargin: '-120px 0px -120px 0px' });

      var canvas = this.section.querySelector('.tiles-canvas');
      if (canvas) this.stickyObserver.observe(canvas);
    }

    cards() {
      return Array.from(this.panel.querySelectorAll('.product-card')).map((card) => {
        var chips = Array.from(card.querySelectorAll('.size-chip[data-size]'));
        var status = card.querySelector('.size-chip--status');
        return {
          el: card,
          type: card.dataset.productType || '',
          groups: (card.dataset.cardGroups || '').split(',').filter((entry) => entry !== ''),
          status: status ? status.dataset.state : '',
          chips: chips,
          sizes: chips.map((chip) => ({
            token: chip.dataset.size,
            label: chip.dataset.label || chip.textContent.trim(),
            state: chip.dataset.state
          }))
        };
      });
    }

    matches(card, state) {
      if (state.groups.length && !card.groups.some((group) => state.groups.indexOf(group) > -1)) return false;
      if (state.types.length && state.types.indexOf(card.type) === -1) return false;
      if (!state.now && !state.sizes.length) return true;

      if (!card.sizes.length) {
        if (state.sizes.length) return false;
        return card.status === 'now';
      }

      return card.sizes.some((size) => {
        if (size.state === 'out') return false;
        if (state.sizes.length && state.sizes.indexOf(size.token) === -1) return false;
        if (state.now && size.state !== 'now') return false;
        return true;
      });
    }

    readState() {
      var form = this.forms[0];
      var state = { now: false, groups: [], types: [], sizes: [] };
      if (!form) return state;

      state.now = !!form.querySelector('[data-group="now"]:checked');
      form.querySelectorAll('[data-group="tile"]:checked').forEach((input) => state.groups.push(input.value));
      form.querySelectorAll('[data-group="type"]:checked').forEach((input) => state.types.push(input.value));
      form.querySelectorAll('[data-group="size"]:checked').forEach((input) => state.sizes.push(input.value));
      return state;
    }

    onChange(event) {
      var input = event.target;
      if (!input.dataset || !input.dataset.group) return;

      var form = input.closest('form[data-tile-form]');
      if (!form || form.dataset.tileSection !== this.sectionId) return;

      this.forms.forEach((other) => {
        if (other === form) return;
        var twin = other.querySelector('[data-group="' + input.dataset.group + '"][value="' + CSS.escape(input.value) + '"]');
        if (twin) twin.checked = input.checked;
      });

      this.state = this.readState();
      this.apply();
    }

    onRemove(event) {
      var trigger = event.target.closest('[data-remove-group]');
      if (!trigger) return;

      event.preventDefault();
      var group = trigger.dataset.removeGroup;
      var value = trigger.dataset.removeValue;

      this.forms.forEach((form) => {
        form.querySelectorAll('[data-group]').forEach((input) => {
          if (group === 'all') {
            input.checked = false;
          } else if (input.dataset.group === group && (value === undefined || input.value === value)) {
            input.checked = false;
          }
        });
      });

      this.state = this.readState();
      this.apply();
    }

    refresh() {
      this.build();
      this.apply();
    }

    build() {
      var cards = this.cards();
      var types = [];
      var sizes = {};

      cards.forEach((card) => {
        if (card.type && types.indexOf(card.type) === -1) types.push(card.type);
        card.sizes.forEach((size) => {
          if (!sizes[size.token]) sizes[size.token] = { token: size.token, label: size.label, meta: classify(size.label) };
        });
      });

      types.sort((a, b) => a.localeCompare(b, 'de'));

      var buckets = {};
      GROUPS.forEach((group) => (buckets[group] = []));
      Object.keys(sizes).forEach((token) => buckets[sizes[token].meta.group].push(sizes[token]));
      GROUPS.forEach((group) => buckets[group].sort((a, b) => sortKey(a.meta).localeCompare(sortKey(b.meta))));

      var labels = (this.dataset.groupValues || '').split('~').map((label) => label.trim());
      var tiles = [];
      labels.forEach((label, index) => {
        if (!label) return;
        if (!cards.some((card) => card.groups.indexOf(String(index)) > -1)) return;
        tiles.push({ token: String(index), label: label });
      });

      if (tiles.length > 1) {
        var taken = tiles.map((tile) => tile.label.toLowerCase());
        types = types.filter((type) => taken.indexOf(type.toLowerCase()) === -1);
      }

      this.groups = { types: types, buckets: buckets, tiles: tiles };

      var kept = this.readState();
      this.forms.forEach((form) => {
        form.innerHTML = '';
        form.appendChild(this.buildSwitch(form.dataset.tileForm));
        if (tiles.length > 1) form.appendChild(this.buildList('tile', this.dataset.labelGroup, tiles, form.dataset.tileForm));
        if (types.length > 1) form.appendChild(this.buildList('type', this.dataset.labelCategory, types.map((type) => ({ token: type, label: type })), form.dataset.tileForm));
        GROUPS.forEach((group) => {
          if (!buckets[group].length) return;
          form.appendChild(this.buildList('size', this.headingFor(group), buckets[group], form.dataset.tileForm, group));
        });

        form.querySelectorAll('[data-group]').forEach((input) => {
          if (input.dataset.group === 'now') input.checked = kept.now;
          if (input.dataset.group === 'tile') input.checked = kept.groups.indexOf(input.value) > -1;
          if (input.dataset.group === 'type') input.checked = kept.types.indexOf(input.value) > -1;
          if (input.dataset.group === 'size') input.checked = kept.sizes.indexOf(input.value) > -1;
        });
      });

      this.state = this.readState();
    }

    headingFor(group) {
      if (group === 'breite') return this.dataset.labelWidth;
      if (group === 'laenge') return this.dataset.labelLength;
      if (group === 'weitere') return this.dataset.labelOther;
      return this.dataset.labelSize;
    }

    buildSwitch(context) {
      var id = 'TileFacetNow-' + this.sectionId + '-' + context;
      var wrapper = document.createElement('div');
      wrapper.className = 'details';
      wrapper.setAttribute('data-filter', '');
      wrapper.innerHTML =
        '<div class="details__summary flex items-center justify-between gap-2">' +
          '<label for="' + id + '" class="text-base-xl font-medium cursor-pointer"></label>' +
          '<input class="switch" id="' + id + '" type="checkbox" value="1" data-group="now" />' +
        '</div>';
      wrapper.querySelector('label').textContent = this.dataset.labelNow;
      return wrapper;
    }

    buildList(group, heading, values, context, axis) {
      var details = document.createElement('details', { is: 'accordion-details' });
      details.className = 'details' + (this.hasAttribute('data-collapsed') ? '' : ' active');
      details.setAttribute('is', 'accordion-details');
      details.setAttribute('data-filter', '');
      if (!this.hasAttribute('data-collapsed')) details.open = true;

      var summary = document.createElement('summary');
      summary.className = 'details__summary flex items-center justify-between gap-2 cursor-pointer';
      var title = document.createElement('span');
      title.className = 'text-base-xl font-medium';
      title.textContent = heading;
      summary.appendChild(title);
      var chevron = this.querySelector('template[data-icon="chevron"]');
      if (chevron) summary.appendChild(chevron.content.cloneNode(true));
      details.appendChild(summary);

      var content = document.createElement('div');
      content.className = 'details__content';
      var list = document.createElement('ul');
      list.className = 'list grid gap-3';
      list.setAttribute('role', 'list');

      values.forEach((value, index) => {
        var id = 'TileFacet-' + this.sectionId + '-' + context + '-' + group + '-' + (axis || '') + '-' + index;
        var item = document.createElement('li');
        item.className = 'flex items-center gap-3';
        item.innerHTML =
          '<input class="checkbox" type="checkbox" id="' + id + '" data-group="' + group + '" />' +
          '<label for="' + id + '" class="flex items-baseline gap-1">' +
            '<span data-value-label></span>' +
            '<span class="text-sm text-opacity" data-value-count></span>' +
          '</label>';
        item.querySelector('input').value = value.token;
        item.querySelector('[data-value-label]').textContent = value.label;
        list.appendChild(item);
      });

      content.appendChild(list);
      details.appendChild(content);
      return details;
    }

    apply() {
      var cards = this.cards();
      var state = this.state;
      var shown = 0;

      cards.forEach((card) => {
        var visible = this.matches(card, state);
        card.el.hidden = !visible;
        if (visible) shown++;
        this.paintChips(card, state);
      });

      this.paintCounts(cards, state);
      this.paintActive(state);
      this.paintLegend(state);

      var count = state.groups.length + state.types.length + state.sizes.length + (state.now ? 1 : 0);

      this.badges.forEach((badge) => {
        badge.textContent = count;
        badge.hidden = count === 0;
      });

      this.totals.forEach((el) => (el.textContent = shown));

      var results = this.querySelector('[data-tile-results]');
      if (results) {
        results.textContent = (this.dataset.labelCount || '')
          .replace('[shown]', shown)
          .replace('[total]', cards.length);
      }
    }

    paintChips(card, state) {
      var filtering = state.now || state.sizes.length > 0;
      var overflow = card.el.querySelector('[data-size-overflow]');

      if (!filtering) {
        card.chips.forEach((chip) => (chip.hidden = false));
        if (overflow) overflow.hidden = false;
        return;
      }

      var kept = card.chips.filter((chip) => {
        if (state.sizes.length && state.sizes.indexOf(chip.dataset.size) === -1) return false;
        if (state.now && chip.dataset.state !== 'now') return false;
        return true;
      });

      if (!kept.length) kept = card.chips;

      card.chips.forEach((chip) => (chip.hidden = kept.indexOf(chip) === -1));
      if (overflow) overflow.hidden = kept.length !== card.chips.length;
    }

    paintCounts(cards, state) {
      this.forms.forEach((form) => {
        form.querySelectorAll('[data-group="tile"], [data-group="type"], [data-group="size"]').forEach((input) => {
          var probe = { now: state.now, groups: state.groups.slice(), types: state.types.slice(), sizes: state.sizes.slice() };
          if (input.dataset.group === 'tile') probe.groups = [input.value];
          else if (input.dataset.group === 'type') probe.types = [input.value];
          else probe.sizes = [input.value];

          var count = cards.filter((card) => this.matches(card, probe)).length;
          var label = input.parentElement.querySelector('[data-value-count]');
          if (label) label.textContent = '(' + count + ')';
          input.disabled = count === 0 && !input.checked;
        });
      });
    }

    paintActive(state) {
      var container = this.querySelector('[data-tile-active]');
      if (!container) return;

      container.innerHTML = '';
      var pills = [];
      var known = this.groups || {};
      var buckets = known.buckets || {};

      if (state.now) pills.push({ group: 'now', value: '1', label: this.dataset.labelNow });
      state.groups.forEach((token) => {
        var tile = (known.tiles || []).filter((entry) => entry.token === token)[0];
        pills.push({ group: 'tile', value: token, label: tile ? tile.label : token });
      });
      state.types.forEach((type) => pills.push({ group: 'type', value: type, label: type }));
      state.sizes.forEach((token) => {
        var entry = null;
        GROUPS.forEach((group) => {
          (buckets[group] || []).forEach((size) => {
            if (size.token === token) entry = size;
          });
        });
        pills.push({ group: 'size', value: token, label: entry ? entry.label : token });
      });

      pills.forEach((pill) => {
        var node = document.createElement('div');
        node.className = 'removable-facet flex items-center justify-between gap-3 lg:gap-4 text-xs lg:text-sm leading-none';
        node.innerHTML =
          '<div class="facet-title flex items-center gap-2"></div>' +
          '<a class="block relative" href="#" role="button" data-remove-group="' + pill.group + '">' +
            '<span class="btn-text"></span>' +
          '</a>';
        node.querySelector('.facet-title').textContent = pill.label;
        var remove = node.querySelector('a');
        remove.dataset.removeValue = pill.value;
        remove.setAttribute('aria-label', (this.dataset.labelRemove || '').replace('[name]', pill.label));
        var icon = this.querySelector('template[data-icon="remove"]');
        if (icon) remove.querySelector('.btn-text').appendChild(icon.content.cloneNode(true));
        container.appendChild(node);
      });

      if (pills.length > 1) {
        var clear = document.createElement('a');
        clear.className = 'facet-clear-all link text-xs lg:text-sm';
        clear.href = '#';
        clear.setAttribute('role', 'button');
        clear.dataset.removeGroup = 'all';
        clear.textContent = this.dataset.labelClearAll;
        container.appendChild(clear);
      }
    }

    paintLegend(state) {
      var legend = document.getElementById(this.dataset.legend);
      if (!legend) return;

      legend.querySelectorAll('[data-legend-state]').forEach((item) => {
        item.hidden = state.now && item.dataset.legendState !== 'now';
      });
    }
  }

  customElements.define('tile-filter', TileFilter);
})();
